<template>
    <!--<div id="contactsMain" class="card">-->
    <div id="contactsMain">
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Contract Specifics</div>
                </div>
                <br>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplClients' id="clientName" name="clientName" width="60%" v-model="data.clientId" :select='onClientChange' floatLabelType='Auto' :dataSource='clients' :fields="{text: 'name', value: 'id' }" placeholder="Client" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplStatus' id="status" name="status" width="60%" v-model="data.status" :dataSource='contractStatus' :fields="{text: 'name', value: 'id' }" placeholder="Status" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplStates' id="state" name="state" width="60%" v-model="preStateId" :enabled="false" :select='onStateChange' :dataSource='states' :fields="{text: 'name', value: 'id' }" placeholder="Country" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="supplier" ref='dplSuppliers' name="supplier" width="60%" v-model="preSupplierId" :select='onSuppliersChange' :dataSource='suppliers' :enabled='supplierEnabled' :fields="{text: 'name', value: 'id' }" placeholder="Supplier" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="company" ref='dplCopmany' name="company" width="60%" v-model="preCompanyId" :enabled='companyEnabled' :select='onCompanyChange' :dataSource='companies' :fields="{text: 'name', value: 'id' }" placeholder="Company" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="utility" name="utility" ref='dplUtility' width="60%" v-model="preUtilityId" :enabled='utilityEnabled' :dataSource='utilities' :select='onUtilityChange' :fields="{text: 'name', value: 'id' }" placeholder="Utility" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group contract-name-check required-input">
                        <ejs-textbox id='contractName' ref="contractName" name="contractName" width="60%" :disabled="false" floatLabelType="Auto" v-model="data.contractName" placeholder="Contract Name"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='duration' name="duration" width="60%" floatLabelType="Auto" :disabled="true" v-model="data.duration" placeholder="Duration"></ejs-textbox>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 d-flex justify-content-center input-group contract-name-check box-auto">
                        <ejs-checkbox id="autoNaming" ref="chBoxAuto" class="auto-nameCheck" name="autoNaming" :checked="data.isAutoNamingOn" :change='onCheckAutoNaming' :disabled="false" v-model="data.isAutoNamingOn" label="Auto naming contract" floatLabelType='Auto'></ejs-checkbox>
                    </div>
                    <div class="form-group col-md-7 d-flex justify-content-center input-group">

                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-datepicker ref="dpStartDate" id="startDate" name="startDate" floatLabelType="Auto" placeholder="Start Date" width="60%" v-model="data.startDate" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-datepicker ref="dpSignedDate" id="signedDate" name="signedDate" floatLabelType="Auto" placeholder="Signed Date" width="60%" v-model="data.signedDate" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-datepicker id="endDate" name="endDate" ref="dpEndDate" floatLabelType="Auto" placeholder="End Date" width="60%" v-model="data.endDate" :change='onEndDateChange' :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref="dplSellback" id="sellback" name="sellback" floatLabelType="Auto" width="60%" v-model="data.sellback" :dataSource='sellbacks' :fields="{text: 'name', value: 'id' }" placeholder="Sellback" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplRiskManager' id="riskManager" name="riskManager" width="60%" v-model="data.riskManagerId" :dataSource='riskManagers' :fields="{text: 'name', value: 'id' }" placeholder="Risk Manager" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplFutureExchange' id="futureExchange" name="futureExchange" width="60%" :enabled="false" v-model="preFutureExchangeId" :dataSource='futureExchange' :fields="{text: 'name', value: 'id' }" placeholder="Futures Market Exchange" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-multiselect id='products' width="60%" ref='mlsProducts' :change="onProductChange" :enabled="false" floatLabelType="Auto" name="products" v-model='preProductIds' :dataSource='products' :fields="{text: 'name', value: 'id' }" placeholder="Product"></ejs-multiselect>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplSpotExchange' id="spotExchange" name="spotExchange" width="60%" :enabled="false" v-model="preSpotExchangesId" :dataSource='spotExchanges' :fields="{text: 'name', value: 'id' }" placeholder="Spot Market Exchange" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-multiselect id='priceAreas' width="60%" ref='mlsPriceAreas' :enabled="false" floatLabelType="Auto" name="priceAreas" v-model='prePricingAreaIds' :change="onPriceAreaChange" :dataSource='priceAreas' :fields="{text: 'name', value: 'id' }" placeholder="Price Areas"></ejs-multiselect>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-multiselect id='identifiers'
                                         ref='mlsIdentifiers'
                                        width="60%"
                                         mode="Box"
                                        cssClass="custom-white-chips"
                                         :select="onIdentifierSelect"
                                         :open="onPopupOpen"
                                         :removed="onIdentifierRemoved"
                                         @clearing="onIdentifierCleared"
                                         :enabled="identifierEnabled"
                                         v-model='preIdentifierIds'
                                         :dataSource='identifiers'
                                         :fields="{text: 'name', value: 'compositeKey' , disabled: 'IsDisabled' }"
                                         placeholder="Identifier"
                                         floatLabelType="Auto"
                                         name="identifiers"></ejs-multiselect>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="volumeUnit" ref='dplVolumeUnit' name="volumeUnit" width="60%" v-model="data.volumeUnitId" :dataSource='volumeUnits' :dataBound='onVolumeDataBound' :fields="{text: 'name', value: 'id' }" placeholder="Volume Unit" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref="dpltradingUnit" id="tradingUnit" name="tradingUnit" width="60%" :select="onTradingUnitSelect" :dataBound="onTradingUnitDataBound" v-model="data.tradingUnitId" :dataSource='tradingUnits' :fields="{text: 'name', value: 'id' }" placeholder="Trading Unit" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref="dplReferenceType" id="referenceType" name="referenceType" width="60%" v-model="data.referenceTypeId" :dataSource='referenceTypes' :fields="{text: 'name', value: 'id' }" placeholder="Reference Type" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group" :class="{ hideEl: hideTradeApportionment }">
                        <ejs-dropdownlist ref="dpltradeApportionment" id="tradeApportionment" :enabled="false" name="tradeApportionment" width="60%" v-model="data.tradeApportionmentId" :dataSource='tradeApportionments' :fields="{text: 'name', value: 'id' }" placeholder="% Trade Apportionment " floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-multiselect ref="mlTradablePeriod" id='tradablePeriod' :change="onTradablePeriodChange" :removing="onTradablePeriodRemoving" width="60%" floatLabelType="Auto" name="tradablePeriod" v-model='data.tradablePeriods' :dataSource='TradablePeriods' :fields="{text: 'name', value: 'id' }" placeholder="Tradeable Period"></ejs-multiselect>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref="dplSpot" id="spot" name="spot" width="60%" v-model="data.spot" :dataSource='spots' :fields="{text: 'name', value: 'id' }" placeholder="Spot" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref="dplDefaultMechanism" id="defaultMechanism" name="defaultMechanism" width="60%" v-model="defaultMechanismId" :change='onDefaultMechanismChange' :dataSource='defaultMechanism' :fields="{text: 'name', value: 'id' }" placeholder="Default Mechanism" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref="dplcontractType" id="contractType" name="contractType" width="60%" v-model="data.contractTypeId" :dataSource='contractTypes' :fields="{text: 'name', value: 'id' }" placeholder="Contract type" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <!--<div class="form-group col-md-6 d-flex justify-content-center input-group">
                    </div>-->
                </div>
                <div class="form-row" v-show="displayAutoFixType">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox floatLabelType="Auto" placeholder="Auto Fix Type" v-model="autoFixTypeName" id="autoFixTypePeriodId" name="autoFixTypePeriodId" width="60%" :readonly="true"></ejs-textbox>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-button cssClass="e-primary " style="max-height: 40px;" v-on:click.native='syncData'>Sync Default Deadline Historical Data</ejs-button>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-uploader ref="uploadContract" cssClass="uploader-noWidth" :buttons="{browse: 'Upload Contract Files'}" id='contractFiles' class="ignore-validation" name="contractFiles" :asyncSettings="path" :uploading="addHeaders" :success="onUploadSuccess"></ejs-uploader>
                        <div>
                            <ejs-dropdownbutton ref="refDownloadContract" name="btnDownloadContract" :disabled="false" id="btnDownloadContract" cssClass="e-success alfa-light-purple" :items='contractFileitems' :select="onDownloadContractClick">Download Contract</ejs-dropdownbutton>
                            <ejs-dropdownbutton ref="refRemoveContract" name="btnRemoveContract" :disabled="false" id="btnRemoveContract" cssClass="e-primary" :items='contractFileitems' :select="onRemoveContractClick">Remove Contract</ejs-dropdownbutton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Strategy</div>
                </div>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id="strategyInPlace" ref="dplStrategyInPlace" name="strategyInPlace" width="60%" v-model="data.strategyInPlace" :change='onStrategyInPlace' :dataSource='sellbacks' :fields="{text: 'name', value: 'id' }" placeholder="Strategy in place" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id="strategyType" ref="dplStrategyType" name="strategyType" width="60%" v-model="data.strategyTypeId" :dataSource='strategyTypes' :fields="{text: 'name', value: 'id' }" placeholder="Strategy Type" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-datepicker id="strategySignedDate" ref="dplStrategySignedDate" name="strategySignedDate" floatLabelType='Auto' placeholder="Strategy Signed Date" width="60%" v-model="data.strategySignedDate" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                    </div>

                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group"></div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-uploader ref="uploadStrategy" cssClass="uploader-noWidth" id='strategyFile' class="ignore-validation" name="strategyFile" :asyncSettings="strategyPath" :uploading="addHeaders" :buttons="{browse: 'Upload Strategy File'}" :success="onStrategyUploadSuccess"></ejs-uploader>
                        <div>
                            <ejs-dropdownbutton ref="refDownloadStrategy" name="btnDownloadStrategy" :disabled="false" id="btnDownloadStrategy" cssClass="e-success alfa-light-purple" :items='strategyFileitems' :select="onDownloadStrategyClick">Download Strategy File</ejs-dropdownbutton>
                            <ejs-dropdownbutton ref="refRemoveStrategy" name="btnRemoveStrategy" :disabled="false" id="btnRemoveStrategy" cssClass="e-primary" :items='strategyFileitems' :select="onRemoveStrategyClick">Remove Strategy File</ejs-dropdownbutton>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <br>
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Trading Desk</div>
                </div>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <div class="d-flex col-md-6 justify-content-center input-group">
                        <label class="e-float-text e-label-top">Contact Details</label>
                        <ejs-textbox id='acmName' name="acmName" width="60%" floatLabelType="Auto" v-model="data.accountManager" placeholder="Name"></ejs-textbox>
                        <ejs-textbox id='acEmail' name="acmEmail" width="60%" floatLabelType="Auto" v-model="data.accountManagerEmail" placeholder="Email"></ejs-textbox>
                        <ejs-textbox id='acmPhone' name="acmPhone" width="60%" floatLabelType="Auto" v-model="data.accountManagerPhone" placeholder="Phone"></ejs-textbox>
                    </div>
                    <div class="col-md-6">
                        <div class="form-row justify-content-center">
                            <div class="col-md-3">
                                <ejs-numerictextbox id='clickFee' name="clickFee" floatLabelType="Auto" v-model="data.clickFee" placeholder="Click Fee"></ejs-numerictextbox>
                            </div>
                            <div class="col-md-3">
                                <ejs-dropdownlist id="clickFeeVolumeUnit" name="clickFeeVolumeUnit" v-model="data.clickFeeVolumeUnitId" :dataSource='volumeUnits' :fields="{text: 'name', value: 'id' }" placeholder="Volume Unit" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="col-md-3">
                                <ejs-numerictextbox id='unclickFee' name="unclickFee" floatLabelType="Auto" v-model="data.unClickFee" placeholder="Un-click Fee"></ejs-numerictextbox>
                            </div>
                            <div class="col-md-3">
                                <ejs-dropdownlist id="unClickFeeVolumeUnit" name="unClickFeeVolumeUnit" v-model="data.unClickFeeVolumeUnitId" :dataSource='volumeUnits' :fields="{text: 'name', value: 'id' }" placeholder="Volume Unit" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center">
                        <ejs-textbox id='formula' :multiline="true" name="formula" width="60%" floatLabelType="Auto" v-model="data.formula" placeholder="Formula"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center">
                        <ejs-textbox id='tradingHours' :multiline="true" name="tradingHours" width="60%" floatLabelType="Auto" v-model="data.tradingHours" placeholder="Trading Hours"></ejs-textbox>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center">
                        <ejs-textbox id='spotFormula' :multiline="true" name="spotFormula" width="60%" floatLabelType="Auto" v-model="data.spotFormula" placeholder="Spot Formula"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center">
                        <ejs-textbox id='tradingProcedure' :multiline="true" name="tradingProcedure" width="60%" floatLabelType="Auto" v-model="data.tradingProcedure" placeholder="Trading Procedure"></ejs-textbox>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="e-card">
            <div class="e-card-content">
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        </div>
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-6">
                            <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                            <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--</div>-->
</template>

<script>
    import Vue from "vue";
    import { DropDownListPlugin, MultiSelectPlugin, MultiSelectComponent } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion'
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import router from '../../router/index';
    import { Query } from '@syncfusion/ej2-data';
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);
    Vue.use(ToastPlugin);
    Vue.use(DropDownButtonPlugin);

    let initConctractName;
    export default {
        name: 'ContractForm',
        props: ['tabInstance', 'notificationService'],
        created() {
            //debugger;
            apis.protectedApi(`utils/volumeUnits`)
                .then(response => {
                    this.volumeUnits = response.data;
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                });
            apis.protectedApi(`utils/tradingUnits`)
                .then(response => {
                    this.tradingUnits = response.data;
                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                });
            let clientId = this.$route.params.clientId;
            if (clientId) {
                this.data.clientId = parseInt(clientId);
            }
            if (!store.state.selectedContractId) return;
            apis.protectedApi(`contract/${store.state.selectedContractId}`)
                .then(response => {
                    this.data = response.data;
                    const identifierSourcesClone =
                        JSON.parse(JSON.stringify(response.data.identifierSources || []));
                    this.loadedIdentifierSources = identifierSourcesClone;
                    this.contractFileUrls = response.data.contractFileUrl ? response.data.contractFileUrl.split(',') : [];
                    this.contractFileitems = this.getContractUrl(this.contractFileUrls);
                    this.strategyFileUrls = response.data.strategyFileUrl ? response.data.strategyFileUrl.split(',') : [];
                    this.strategyFileitems = this.getStrategyUrl(this.strategyFileUrls);
                    this.isInATG = response.data.isInATG;
                    this.contractHasActiveTrades = response.data.hasActiveTrades;
                    this.populateStates(this.data.clientId);
                    this.populateProduct(this.data.utilityTypeId, this.data.stateId);
                    this.populateCompanies(this.data.clientId, this.data.stateId);
                    this.populateUtilities(this.data.supplierId);
                    this.enableStrategySection(this.data.strategyInPlace);
                    this.populateSuppliers(this.data.stateId);
                    this.populateFutureExchange(this.data.stateId);
                    this.populateSpotExchanges(this.data.stateId);
                    this.getCurrentMarketPriceUnit(store.state.selectedContractId);
                    this.populatePriceAreas(this.data.stateId, this.data.utilityTypeId, this.data.productIds, false, identifierSourcesClone);
                    this.populateIdentifier(this.data.utilityTypeId, this.data.stateId, this.data.productIds, this.data.pricingAreaIds, false, identifierSourcesClone);
                    store.commit('setContractProducts', this.data.productIds);
                    store.commit('setIsContractSellback', this.data.sellback);
                    store.commit('setContractSelectedUtility', this.data.utilityTypeId);
                    store.commit('setContractHasActiveTrades', this.data.hasActiveTrades);
                    store.commit('setIsContractExpired', new Date(this.data.endDate) < new Date());
                    store.commit('setHasPriceAreas', this.data.pricingAreaIds.length > 0 ? true : false)
                    initConctractName = this.data.contractName;
                    if (response.data.isAutoNamingOn) {
                        this.$refs.contractName.ej2Instances.enabled = false;
                    }

                    document.getElementById('headerContract').textContent = this.data.contractName;

                    this.hideTabDefaultDeadline(this.data.defaultMechanismName);

                    this.defaultMechanismId = this.data.defaultMechanismId;
                    if (this.data.defaultMechanismName == "Auto fix") {

                        this.displayAutoFixType = true;
                        var selectedPeriodNames = this.data.autoFixTypePeriodName;
                        this.autoFixTypePeriodId = this.data.autoFixTypePeriodId;

                        if (selectedPeriodNames == "Calendar") {

                            this.autoFixTypeName = `${selectedPeriodNames.toUpperCase().slice(0, 3)}+1`;
                        }
                        else {
                            this.autoFixTypeName = `${Array.from(selectedPeriodNames)[0]}+1`
                        }
                    }
                    else {
                        this.displayAutoFixType = false;
                    }

                    // this.contractForms.rules.defaultMechanism.required = this.data.defaultMechanismName == "" ? false : true;

                }).catch(e => {
                    if (e.response) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            if (store.state.selectedContractId)
                showSpinner(document.getElementById('mainSpinner'));

            this.contractForms = new FormValidator("#contactsMain", this.options);
            if (!store.state.selectedContractId) {
                this.onTradablePeriodChange();
                this.enableStrategySection(false);
            }
            let clientId = this.$route.params.clientId;
            if (clientId) {
                this.populateStates(clientId, true);
            }
        },
        data() {
            return {
                data: {},
                blockedProductId: null,
                blockedAreaId: null,
                contractForms: null,
                store: store,
                states: [],
                utilities: [],
                companies: [],
                suppliers: [],
                spotExchanges: [],
                futureExchange: [],
                contractFileUrls: [],
                blockedCombinations: [], // array of { productId, areaId }
                loadedIdentifierSources: [],
                strategyFileUrls: [],
                spots: [{ "name": "Yes", "id": true }, { "name": "No", "id": false }],
                sellbacks: [{ "name": "Yes", "id": true }, { "name": "No", "id": false }],
                contractStatus: [{ "name": "Active", "id": true }, { "name": "Inactive", "id": false }],
                preStateId: null,
                volumeUnits: [],
                tradingUnits: [],
                preCompanyId: null,
                preUtilityId: null,
                preProductIds: null,
                preIdentifierIds: null,
                prePricingAreaIds: null,
                preSupplierId: null,
                preFutureExchangeId: null,
                preSpotExchangesId: null,
                identifiers: null,
                products: null,
                priceAreas: null,
                extensions: '.pdf',
                defaultMechanismId: null,
                supplierEnabled: false,
                identifierEnabled: false,
                utilityEnabled: false,
                tradeApportionments: [
                    { "name": "% Split by Traded Period", "id": 1 },
                    { "name": "% Split by Month", "id": 2 }],
                hideTradeApportionment: false,
                path: {
                    saveUrl: `${urls.apiBaseUrl}upload/contract`,
                },
                strategyPath: {
                    saveUrl: `${urls.apiBaseUrl}upload/strategyfile`,
                },
                contractUrl: null,
                isInATG: null,
                contractHasActiveTrades: false,
                companyEnabled: false,
                autoFixTypeName: "",
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'clientName': {
                            required: true
                        },
                        'status': {
                            required: true
                        },
                        'state': {
                            required: true
                        },
                        'utility': {
                            required: true
                        },
                        'company': {
                            required: true
                        },
                        'riskManager': {
                            required: true
                        },
                        'contractName': {
                            required: true
                        },
                        'duration': {
                            required: false
                        },
                        'startDate': {
                            required: true
                        },
                        'endDate': {
                            required: true
                        },
                        'signedDate': {
                            required: true
                        },
                        'sellback': {
                            required: true
                        },
                        'supplier': {
                            required: true
                        },
                        'futureExchange': {
                            required: true
                        },
                        'identifiers': {
                            required: true
                        },
                        'spot': {
                            required: true
                        },
                        'products': {
                            required: true
                        },
                        'spotExchange': {
                            required: true
                        },
                        'volumeUnit': {
                            required: true
                        },
                        'tradingUnit': {
                            required: true
                        },
                        'tradablePeriod': {
                            required: true
                        },
                        'tradeApportionment': {
                            required: false
                        },
                        'referenceType': {
                            required: true
                        },
                        'referenceType': {
                            required: true
                        },
                        'contractFiles': {
                            required: false
                        },
                        'strategyType': {
                            required: false
                        },
                        'strategySignedDate': {
                            required: false
                        },
                        'defaultMechanism': {
                            required: true
                        },
                        'priceAreas': {
                            required: false
                        }
                    }
                },
                contractFileitems: [],
                strategyFileitems: [],
                allowFiltering: true,
                displayAutoFixType: false,
                canSave: this.$store.state.permissions["Permissions.Contract.Create"],
            }
        },
        methods: {
            actionComplete: function (args) {
            },
            onCheckAutoNaming: function (args) {
                if (args.checked) {
                    this.createContaractName(null, null);
                    this.$refs.contractName.ej2Instances.enabled = false;
                } else {
                    this.$refs.contractName.ej2Instances.enabled = true;
                    document.getElementById("contractName").ej2_instances[0].value = "";
                    document.getElementById("contractName").ej2_instances[0].element.value = "";
                }
            },
            getContractUrl: function (contractFileUrls) {
                var items = [];
                for (let index in contractFileUrls) {
                    items.push({ text: contractFileUrls[index].split(/[\s/]+/).pop().slice(0, -4), id: contractFileUrls[index] });
                }
                return items;
            },
            getStrategyUrl: function (strategyFileUrls) {
                var items = [];
                for (let index in strategyFileUrls) {
                    items.push({ text: strategyFileUrls[index].split(/[\s/]+/).pop().slice(0, -4), id: strategyFileUrls[index] });
                }
                return items;
            },
            onDownloadContractClick: function (e) {
                const link = document.createElement('a');
                link.href = e.item.id;
                link.click();
            },
            onRemoveContractClick: function (e) {
                if (this.contractFileUrls.includes(e.item.id)) {

                    const listUrl = this.contractFileUrls;
                    const url = listUrl.indexOf(e.item.id);
                    listUrl.splice(url, 1);

                }
                this.contractFileitems = this.getContractUrl(this.contractFileUrls);
                let message = { title: 'Warning !', content: `Contract file ${e.item.text} removed successfully.`, cssClass: 'e-toast-warning' };
                this.$root.$emit('showToast', message);
            },
            onDownloadStrategyClick: function (e) {
                const link = document.createElement('a');
                link.href = e.item.id;
                link.click();
            },
            onRemoveStrategyClick: function (e) {
                if (this.strategyFileUrls.includes(e.item.id)) {

                    const listUrl = this.strategyFileUrls;
                    const url = listUrl.indexOf(e.item.id);
                    listUrl.splice(url, 1);

                }
                this.strategyFileitems = this.getStrategyUrl(this.strategyFileUrls);
                let message = { title: 'Warning !', content: `Strategy file ${e.item.text} removed successfully.`, cssClass: 'e-toast-warning' };
                this.$root.$emit('showToast', message);
            },
            isContractInATG: function () {
                this.$refs.dplStates.ej2Instances.enabled = false;
                this.$refs.dplUtility.ej2Instances.enabled = false;
                this.$refs.dpStartDate.ej2Instances.enabled = false;
                this.$refs.dpEndDate.ej2Instances.enabled = false;
                this.$refs.dplClients.ej2Instances.enabled = false;
                this.$refs.dplCopmany.ej2Instances.enabled = false;
                this.$refs.mlsProducts.ej2Instances.enabled = false;
                this.$refs.mlsIdentifiers.ej2Instances.enabled = false;//enisa
                this.$refs.mlsPriceAreas.ej2Instances.enabled = false;
                this.$refs.dplVolumeUnit.ej2Instances.enabled = false;
                this.$refs.dpltradingUnit.ej2Instances.enabled = false;
                this.$refs.dpltradeApportionment.ej2Instances.enabled = false;
                this.$refs.mlTradablePeriod.ej2Instances.enabled = false;
                this.$refs.dplDefaultMechanism.ej2Instances.enabled = false;
                //this.$refs.uploadContract.ej2Instances.enabled = false;
                if (this.isInATG) {
                    this.$refs.dplRiskManager.ej2Instances.enabled = false;
                    this.$refs.dplSuppliers.ej2Instances.enabled = false;
                    this.$refs.dplStatus.ej2Instances.enabled = false;
                    this.$refs.dpSignedDate.ej2Instances.enabled = false;
                    this.$refs.dplSellback.ej2Instances.enabled = false;
                    this.$refs.dplFutureExchange.ej2Instances.enabled = false;
                    this.$refs.dplSpotExchange.ej2Instances.enabled = false;
                    this.$refs.dplReferenceType.ej2Instances.enabled = false;
                    this.$refs.dplSpot.ej2Instances.enabled = false;
                    this.$refs.dplDefaultMechanism.ej2Instances.enabled = false;
                }
            },
            getCurrentMarketPriceUnit(id) {
                apis.protectedApi(`${urls.apiBaseUrl}Contract/AditionalTriggerData/${id}`).then(it => {
                    store.commit('setContractMarketUnit', it.data.units);
                    store.commit('setContractMarketUnitName', it.data.unitsName);
                    //set the default riskmanager email and units used on the contract to be loaded for edit dialog
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            onTradingUnitSelect: function (e) {
                var tradingunit = this.tradingUnits.filter(p => p.name == e.itemData.name)[0];
                if (tradingunit && tradingunit.tradingName == '%') {
                    this.$refs.dpltradeApportionment.ej2Instances.enabled = true;
                    this.hideTradeApportionment = false;
                    this.contractForms.rules.tradeApportionment.required = true;

                } else {
                    this.$refs.dpltradeApportionment.ej2Instances.enabled = false;
                    this.contractForms.rules.tradeApportionment.required = false;
                    this.hideTradeApportionment = true;
                }
            },
            onTradingUnitDataBound: function (e) {
                var tradingunit = this.tradingUnits.filter(p => p.id == this.data.tradingUnitId)[0];
                if (tradingunit && tradingunit.tradingName == '%') {

                    this.$refs.dpltradeApportionment.ej2Instances.enabled = true;
                    this.hideTradeApportionment = false;
                } else {
                    this.$refs.dpltradeApportionment.ej2Instances.enabled = false;
                    this.hideTradeApportionment = true;
                }
                store.commit('setContractTradeUnit', this.$refs.dpltradingUnit.ej2Instances.text);
                store.commit('setContractTradeUnitName', tradingunit ? tradingunit.tradingName : "");

            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onUploadSuccess: function (args) {
                var response = JSON.parse(args.e.currentTarget.response);
                if (response.contractUrl) {
                    this.contractFileUrls.push(response.contractUrl);
                    this.contractFileitems = this.getContractUrl(this.contractFileUrls);
                    let message = { title: 'Success!', content: `Contract file ${args.file.id} upload successfully.`, cssClass: 'e-toast-success' };
                    this.$root.$emit('showToast', message);
                }
            },
            onStrategyUploadSuccess: function (args) {
                var response = JSON.parse(args.e.currentTarget.response);
                if (response.strategyUrl) {
                    this.strategyFileUrls.push(response.strategyUrl);
                    this.strategyFileitems = this.getStrategyUrl(this.strategyFileUrls);
                    let message = { title: 'Success!', content: `Strategy file ${args.file.id} upload successfully.`, cssClass: 'e-toast-success' };
                    this.$root.$emit('showToast', message);
                }
            },
            onCompanyChange: function (e) {
                if (this.$refs.chBoxAuto.ej2Instances.checked) {
                    this.createContaractName(null, e)
                }
            },
            onUtilityChange: function (e) {
                this.populateProduct(e.itemData.id, this.preStateId, true);
                if (this.$refs.chBoxAuto.ej2Instances.checked) {
                    this.createContaractName(e, null);
                }
                if (e.isInteracted == true) {
                    this.populatePriceAreas(this.preStateId, e.itemData.id, this.prePricingAreaIds, true);
                }
            },
            onClientChange: function (e) {
                if (this.$refs.chBoxAuto.ej2Instances.checked) {
                    document.getElementById("contractName").ej2_instances[0].value = "";
                    document.getElementById("contractName").ej2_instances[0].element.value = "";
                }
                this.populateStates(e.itemData.id, true);
                this.populateCompanies(e.itemData.id, null, true);
                this.populateSuppliers(null, true);
                this.populateUtilities(null, true);
                if (e.isInteracted == true) {
                    this.populatePriceAreas(null, null, null, true);
                }

            },
            onStateChange: function (e) {
                this.populateCompanies(this.$refs.dplClients.ej2Instances.value, e.itemData.id, true);
                this.populateFutureExchange(e.itemData.id, true);
                this.populateSpotExchanges(e.itemData.id, true);
                this.populateSuppliers(e.itemData.id, true);
                if (e.isInteracted == true) {
                    this.populatePriceAreas(e.itemData.id, this.preUtilityId, this.prePricingAreaIds, true);
                }
            },
            onEndDateChange: function (e) {

                if (this.$refs.chBoxAuto.ej2Instances.checked) {
                    this.createContaractName(null, null);
                }

            },
            onDefaultMechanismChange: function (e) {
                if (e.itemData === null)
                    return;

                this.defaultMechanismId = e.itemData.id;
                this.defaultMechanismName = e.itemData.name;

                if (e.itemData != undefined && e.itemData.name == 'Auto fix') {
                    const derivedIdentifierExist = this.preIdentifierIds.some(item => item.split('_')[0] === "5");
                    const isTradablePeriodMonth = this.data.tradablePeriods.some(item => item == 2);

                    if (derivedIdentifierExist && !isTradablePeriodMonth) {
                        const defaultMechanismDropdown = e.element.ej2_instances[0];
                        defaultMechanismDropdown.value = null;
                        defaultMechanismDropdown.index = -1;
                        defaultMechanismDropdown.text = null;
                        this.defaultMechanismId = null;
                        this.defaultMechanismName = null;

                        this.showErrorDialog("Auto fix cannot be selected as a default mechanism since derived curves are selected as identifiers without a tradeable period month.");
                        
                        return;
                    }

                    this.showErrorDialog("By selecting Auto fix, after save contract Default deadline must be entered for periods.");
                    this.displayAutoFixType = true;
                    var selectedTradeablePeriods = this.data.tradablePeriods;
                    if (selectedTradeablePeriods != undefined && selectedTradeablePeriods != null) {
                        this.$nextTick(() => {
                            this.setAutoFixType(selectedTradeablePeriods);
                        });
                    }
                }
                else {
                    this.displayAutoFixType = false;
                    this.autoFixTypeName = null;
                    this.autoFixTypePeriodId = null;
                }
            },
            setAutoFixType: function (selectedTradablePeriods) {
                var selectedPeriod = null;
                var smallestPeriod = 0;
                if (selectedTradablePeriods.length < 2) {
                    selectedPeriod = this.$refs.mlTradablePeriod.ej2Instances.getDataByValue(selectedTradablePeriods[0]);
                }
                else {
                    var smallestPeriod = selectedTradablePeriods.reduce(function (min, current) {
                        return (current < min) ? current : min;
                    }, selectedTradablePeriods[0]);
                    selectedPeriod = this.$refs.mlTradablePeriod.ej2Instances.getDataByValue(smallestPeriod);
                }
                if (selectedPeriod.name == "Calendar") {
                    this.autoFixTypePeriodId = selectedPeriod.id;
                    this.autoFixTypeName = `${selectedPeriod.name.toUpperCase().slice(0, 3)}+1`;
                }
                else {
                    this.autoFixTypePeriodId = selectedPeriod.id;
                    this.autoFixTypeName = `${Array.from(selectedPeriod.name)[0]}+1`
                }
            },
            createContaractName: function (utility, company) {//New method for create name of contract
                var contractName = document.getElementById("contractName").ej2_instances[0];
                //switch from Client to Company on request from Alba and RM Team 19.01.2023
                //var clientName = this.$refs.dplClients.$el.value;
                var clientName = company == null ? this.$refs.dplCopmany.$el.value : company.itemData.name;

                var countryName = this.$refs.dplStates.$el.value;

                var supplierName = this.$refs.dplSuppliers.$el.value;
                var utilityName = this.$refs.dplUtility.$el.value;
                var endDate = this.$refs.dpEndDate.$el.value;
                var utilityDropName = "";
                if (utility != null) {
                    utilityDropName = utility.itemData.utilityTypeName;
                    utilityName = utilityDropName;
                }

                if (clientName != "" && countryName != "" && supplierName != "" && utilityName != "" && endDate != "") {
                    if (this.states.length == 1) {
                        var countryCodeAlpha2 = this.states[0].alpha2;
                    }
                    else {
                        var countryCodeAlpha2 = this.states.filter(s => s.name == countryName)[0].alpha2;
                    }
                    var dateParts = endDate.split("/");
                    var formattedDate = dateParts[2] + dateParts[1] + dateParts[0];

                    var commodityCode = "";

                    if (utilityName == "Electricity") {
                        commodityCode = "P"

                    }
                    if (utilityName == "Gas") {
                        commodityCode = "G"
                    }

                    var createName = clientName + "_" + countryCodeAlpha2 + "_" + commodityCode + "_" + supplierName + "_" + formattedDate;
                    contractName.value = createName;
                }

            },
            btnSaveClick: function (e) {
                e.preventDefault();
                let formStatus = this.contractForms.validate();
                if (formStatus) {
                    if (this.data.startDate > this.data.endDate) {
                        gridOptions.errorAlert("End Date must be greater than Start Date.");
                        return;
                    }
                    showSpinner(document.getElementById('mainSpinner'));
                    if (store.state.selectedContractId) {
                        if (initConctractName === this.data.contractName) {
                            this.updateContract();
                        } else {
                            apis.protectedApi.get(`contract/validateContractName/?contractName=${encodeURIComponent(this.data.contractName)}`)
                                .then(response => {
                                    if (response.data.isValid) {
                                        this.updateContract();
                                    } else {
                                        hideSpinner(document.getElementById('mainSpinner'));
                                        gridOptions.errorAlert(`Contract with name ${this.data.contractName} already exists, please choose another name.`);
                                    }
                                }).catch(e => {
                                    hideSpinner(document.getElementById('mainSpinner'));
                                    if (e.response) {
                                        gridOptions.errorAlert(e.response.data.message);
                                    }
                                });
                        }
                    } else {
                        apis.protectedApi.get(`contract/validateContractName/?contractName=${encodeURIComponent(this.data.contractName)}`)
                            .then(response => {
                                if (response.data.isValid) {
                                    this.createContract();
                                } else {
                                    hideSpinner(document.getElementById('mainSpinner'));
                                    gridOptions.errorAlert(`Contract with name ${this.data.contractName} already exists, please choose another name.`);
                                }
                            }).catch(e => {
                                hideSpinner(document.getElementById('mainSpinner'));
                                if (e.response) {
                                    gridOptions.errorAlert(e.response.data.message);
                                }
                            });
                    }
                }
            },
            createContract: function () {
                this.data.stateId = this.preStateId;
                this.data.companyId = this.preCompanyId;
                this.data.utilityTypeId = this.preUtilityId;
                this.data.contractFileUrl = this.contractFileUrls && this.contractFileUrls.length > 0 ? this.contractFileUrls.join() : null;
                this.data.strategyFileUrl = this.strategyFileUrls && this.strategyFileUrls.length > 0 ? this.strategyFileUrls.join() : null;
                this.data.productIds = this.preProductIds;
                this.data.pricingAreaIds = this.prePricingAreaIds;
                this.data.supplierId = this.preSupplierId;
                this.data.futureExchangeId = this.preFutureExchangeId;
                this.data.spotExchangeId = this.preSpotExchangesId;
                this.data.autoFixTypePeriodId = this.autoFixTypePeriodId;
                this.data.defaultMechanismId = this.defaultMechanismId;

                //date offset issues
                this.data.startDate = this.fixDateOffset(this.data.startDate);
                if (this.data.signedDate != undefined) {
                    this.data.signedDate = this.fixDateOffset(this.data.signedDate);
                }
                this.data.endDate = this.fixDateOffset(this.data.endDate);
                if (this.data.strategySignedDate)
                    this.data.strategySignedDate = this.fixDateOffset(this.data.strategySignedDate);
                store.commit('setContractProducts', this.data.productIds);
                store.commit('setIsContractSellback', this.data.sellback);
                store.commit('setContractVolumeUnit', this.$refs.dplVolumeUnit.ej2Instances.text);
                store.commit('setContractTradeUnit', this.$refs.dpltradingUnit.ej2Instances.text);

                var tradingunit = this.tradingUnits.filter(p => p.name == this.$refs.dpltradingUnit.ej2Instances.text)[0];
                var volumeunit = this.volumeUnits.filter(p => p.name == this.$refs.dplVolumeUnit.ej2Instances.text)[0];
                store.commit('setContractVolumeUnitName', volumeunit ? volumeunit.volumeName : "");
                store.commit('setContractTradeUnitName', tradingunit ? tradingunit.tradingName : "");
                store.commit('setContractSelectedUtility', this.data.utilityTypeId);
                this.data.productIds = this.preProductIds;
                this.data.pricingAreaIds = this.prePricingAreaIds;

                // --- NEW LOGIC FOR IDENTIFIERS ---
                // Clear out any old versions of the property first
                this.data.identifierSources = [];
                this.data.identifierSources = (this.preIdentifierIds || []).map(key => {
                    const parts = key.split('_');
                    if (parts.length < 5) return null;
                    return {
                        sourceTypeId: parseInt(parts[0]) || 0,
                        identifierSourceId: parseInt(parts[1]) || 0,
                        contractToIdentifierSourceId: parseInt(parts[2]) || 0,
                        productId: parseInt(parts[3]) || 0,
                        pricingAreaId: parts[4] === 'null' ? null : parseInt(parts[4])
                    };
                }).filter(x => x !== null);

                apis.protectedApi.post(`contract`, this.data)
                    .then(response => {
                        if (response.data.error) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            this.showErrorDialog(response.data.error);
                        } else {
                            let message = {
                                title: 'Success!',
                                content: 'Contract is created successfully',
                                cssClass: 'e-toast-success'
                            };

                            store.commit('setCurrentContractId', response.data.contractId);
                            this.tabInstance.items.forEach(e => {
                                //get offpeak product id and match to see if it is selected,if so we can show offpeak price calculator page
                                if (e.header.text == "Off-Peak Price Calculator") {
                                    var selectedUtility = this.utilities.find(p => p.id == this.data.utilityTypeId);
                                    if (selectedUtility != null && selectedUtility.utilityTypeName == "Gas") {
                                        e.disabled = true;
                                    } else {
                                        let productNames = this.products.filter(p => store.state.contractProducts.includes(p.id)).map(p => p.name);
                                        if (productNames.includes("Off-Peak")) {
                                            e.disabled = false;
                                        }
                                        else {
                                            e.disabled = true;
                                        }
                                    }
                                }
                                else {
                                    e.disabled = false;
                                }
                            });
                            this.hideTabDefaultDeadline(null);
                            router.replace({ name: "Contract", params: { contractId: response.data.contractId } }).catch(err => {
                                // Ignore the vuex err regarding  navigating to the page they are already on.
                                if (err.name != "NavigationDuplicated") {
                                    // But print any other errors to the console
                                    console.error(err);
                                }
                            });
                            this.tabInstance.refresh();
                            this.notificationService.show(message);
                        }
                    }).catch(e => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            hideTabDefaultDeadline: function (name) {

                var selectedDM = name == null ? this.$refs.dplDefaultMechanism.ej2Instances.itemData != undefined ? this.$refs.dplDefaultMechanism.ej2Instances.itemData.name : "" : "";
                this.tabInstance.items.forEach(e => {
                    if (e.header.text == "Default Deadline") {
                        e.disabled = name == "Auto fix" || selectedDM == "Auto fix" ? false : true;
                    }
                });
            },
            updateContract: function () {
                //this.data.clientLogo = this.logoUrl;
                this.data.stateId = this.preStateId;
                this.data.companyId = this.preCompanyId;
                this.data.utilityTypeId = this.preUtilityId;
                this.data.contractFileUrl = this.contractFileUrls && this.contractFileUrls.length > 0 ? this.contractFileUrls.join() : null;
                this.data.strategyFileUrl = this.strategyFileUrls && this.strategyFileUrls.length > 0 ? this.strategyFileUrls.join() : null;
                this.data.productIds = this.preProductIds;
                this.data.supplierId = this.preSupplierId;
                this.data.futureExchangeId = this.preFutureExchangeId;
                this.data.spotExchangeId = this.preSpotExchangesId;
                this.data.autoFixTypePeriodId = this.autoFixTypePeriodId;
                this.data.autoFixTypePeriodName = this.autoFixTypeName;
                this.data.defaultMechanismId = this.defaultMechanismId;
                this.data.defaultMechanismName = this.defaultMechanismName;
                this.data.pricingAreaIds = this.prePricingAreaIds;
                //date offset issues
                this.data.startDate = this.fixDateOffset(this.data.startDate);
                if (this.data.signedDate != undefined) {
                    this.data.signedDate = this.fixDateOffset(this.data.signedDate);
                }
                this.data.endDate = this.fixDateOffset(this.data.endDate);
                if (this.data.strategySignedDate)
                    this.data.strategySignedDate = this.fixDateOffset(this.data.strategySignedDate);
                store.commit('setContractProducts', this.data.productIds);
                store.commit('setIsContractSellback', this.data.sellback);
                store.commit('setContractVolumeUnit', this.$refs.dplVolumeUnit.ej2Instances.text);
                store.commit('setContractTradeUnit', this.$refs.dpltradingUnit.ej2Instances.text);
                var tradingunit = this.tradingUnits.filter(p => p.name == this.$refs.dpltradingUnit.ej2Instances.text)[0];
                var volumeunit = this.volumeUnits.filter(p => p.name == this.$refs.dplVolumeUnit.ej2Instances.text)[0];
                store.commit('setContractVolumeUnitName', volumeunit ? volumeunit.volumeName : "");
                store.commit('setContractTradeUnitName', tradingunit ? tradingunit.tradingName : "");

                store.commit('setContractSelectedUtility', this.data.utilityTypeId);

                this.data.identifierSources = [];

                if (this.preIdentifierIds && this.preIdentifierIds.length > 0) {
                    this.data.identifierSources = this.preIdentifierIds.map(key => {
                        const parts = key.split('_');
                        return {
                            sourceTypeId: parseInt(parts[0]),
                            identifierSourceId: parseInt(parts[1]),
                            contractToIdentifierSourceId: parseInt(parts[2]),
                            productId: parseInt(parts[3]),
                            pricingAreaId: parts[4] === 'null' ? null : parseInt(parts[4])
                        };
                    });
                }
                apis.protectedApi.put(`contract`, this.data)
                    .then(response => {
                        let message = {
                            title: 'Success!',
                            content: 'Contract is updated successfully',
                            cssClass: 'e-toast-success'
                        };
                        this.tabInstance.refresh();
                        this.notificationService.show(message);
                    }).catch(e => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            btnBackClick: function (e) {
                router.push({ name: "Contracts" });
            },
            fixDateOffset: function (date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return date;
            },
            onProductChange: function (val) {
                var that = this;
                if (val.isInteracted == true) {
                    this.populatePriceAreas(this.preStateId, this.preUtilityId, val.value, true);
                }

                if (store.state.selectedContractId) {
                    this.tabInstance.items.forEach(e => {
                        //get offpeak product id and match to see if it is selected,if so we can show offpeak price calculator page
                        if (e.header.text == "Off-Peak Price Calculator") {
                            var selectedUtility = that.utilities.find(p => p.id == that.data.utilityTypeId);

                            if (selectedUtility != null && selectedUtility.utilityTypeName == "Gas") {
                                e.disabled = true;
                            } else {
                                var OffpeakProd = that.products.filter(p => p.productName == "Off-Peak");
                                if (OffpeakProd.length === 0) {
                                    e.disabled = true;
                                    return;
                                }
                                var hasOffpeak = val.value.filter(pr => pr == OffpeakProd[0].id);
                                if (hasOffpeak.length > 0) {
                                    e.disabled = false;
                                } else {

                                    var hadOffpeak = val.oldValue != undefined ? val.oldValue.filter(pr => pr == OffpeakProd[0].id) : [];
                                    if (hadOffpeak.length > 0) {
                                        apis.protectedApi(`OffPeakPrice/${store.state.selectedContractId}`)
                                            .then(response => {
                                                if (response.data.result == null || response.data.result.formula == "" || response.data.result.formula == null) {
                                                    e.disabled = true;
                                                }
                                                else {
                                                    this.preProductIds = val.oldValue;
                                                    this.showErrorDialog("In order to remove offpeak product you first need to remove off peak price formula");
                                                }

                                            }).catch(e => {
                                                if (e.response) {
                                                    this.showErrorDialog(e.response.data.message);
                                                }
                                            })
                                    }
                                    else { e.disabled = true; }
                                }
                            }
                        }
                    });
                }

            },
            populateProduct: function (utilityId, stateId, isChangeEvent) {
                this.preProductIds = null;

                apis.protectedApi(`utils/productsByRIC?utilityTypeId=${utilityId}&stateId=${stateId}&contractId=${store.state.selectedContractId}`)
                    .then(response => {
                        this.products = response.data;
                        this.preProductIds = isChangeEvent ? null : this.data.productIds;
                        if (response.data)
                            this.$refs.mlsProducts.ej2Instances.enabled = true;

                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.$refs.dplStates.ej2Instances.enabled = true;
                this.$refs.mlsIdentifiers.ej2Instances.enabled = true;
            },
            onTradablePeriodRemoving: function (e) {
                if (e != undefined) {
                    if (e.isInteracted) {
                        this.$refs.dplDefaultMechanism.ej2Instances.enabled = true;
                        this.data.defaultMechanismId = null;
                        this.displayAutoFixType = false;
                        this.autoFixType = null;
                    }
                }
            },
            populateStates: function (clientId, isChangeEvent) {
                this.preStateId = null;
                apis.protectedApi(`utils/clientStates?clientId=${clientId}`)
                    .then(response => {
                        setTimeout(() => {
                            this.preStateId = isChangeEvent ? null : this.data.stateId;
                        }, 1000)

                        this.states = response.data;
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.$refs.dplStates.ej2Instances.enabled = true;
            },
            populateCompanies: function (clientId, stateId, isChangeEvent) {
                this.preCompanyId = null;
                apis.protectedApi(`utils/clientCompanies?clientId=${clientId}&stateId=${stateId}&companyId=${this.data.companyId}`)
                    .then(response => {
                        this.companies = response.data;
                        setTimeout(() => {
                            this.preCompanyId = isChangeEvent ? null : this.data.companyId;
                        }, 1000)

                    }).catch(e => {
                        if (e.response.data.message)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.companyEnabled = true;
            },
            populateUtilities: function (supplierId, isChangeEvent) {
                this.preUtilityId = null;
                apis.protectedApi(`utils/utilitiesForSupplier?supplierId=${supplierId}`)
                    .then(response => {
                        this.utilities = response.data;
                        setTimeout(() => {
                            this.preUtilityId = isChangeEvent ? null : this.data.utilityTypeId;
                        }, 1000)
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.companyEnabled = true;
                this.utilityEnabled = true;
            },
            populateSuppliers: function (stateId, isChangeEvent) {
                this.preSupplierId = null;
                apis.protectedApi(`utils/suppliers?stateId=${stateId}`)
                    .then(response => {
                        this.suppliers = response.data;
                        setTimeout(() => {
                            this.preSupplierId = isChangeEvent ? null : this.data.supplierId;
                        }, 1000)

                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.supplierEnabled = true;
            },

           
            resetRules: function () {
                this.blockedProductId = null;
                this.blockedAreaId = null;

                //const multiSelectObj = this.$refs.mlsIdentifiers.ej2Instances;
                //var f = this.$refs.mlsIdentifiers.ej2Instances.liCollections;


                if (multiSelectObj) {
                    // 2. Clear the actual selection (Deletes the items from the box)
                    multiSelectObj.value = null;

                    // 3. Directly clean the LI elements using liCollections
                    // This works even if the popup is currently "null" in the document
                    if (multiSelectObj.liCollections && multiSelectObj.liCollections.length > 0) {
                        for (var i = 0; i < multiSelectObj.liCollections.length; i++) {
                            var li = multiSelectObj.liCollections[i];

                            // Remove all manual styling
                            li.classList.remove('e-disabled');
                            li.style.pointerEvents = 'auto';
                            li.style.opacity = '1';
                            li.setAttribute('aria-disabled', 'false');
                        }
                    }
                    multiSelectObj.dataBind();
                }
            },
            onIdentifierRemoved: function (e) {
                if (!e || !e.itemData) return;

                const { productId, pricingAreaId } = e.itemData;

                this.blockedCombinations = this.blockedCombinations.filter(
                    b => !(b.productId === productId && b.areaId === pricingAreaId)
                );
            },
            onIdentifierCleared: function () {
                this.blockedCombinations = [];

                // Only reset all list items when the user clears everything
                this.resetAllListItems();
            },
            resetAllListItems: function () {
                const multiSelectObj = this.$refs.mlsIdentifiers.ej2Instances;
                if (!multiSelectObj || !multiSelectObj.liCollections) return;

                multiSelectObj.liCollections.forEach(li => {
                    li.classList.remove('e-disabled');
                    li.style.pointerEvents = 'auto';
                    li.style.opacity = '1';
                    li.setAttribute('aria-disabled', 'false');
                });

                multiSelectObj.dataBind();
            },
            resetBlockingForCombination: function (productId, pricingAreaId) {
                const multiSelectObj = this.$refs.mlsIdentifiers.ej2Instances;
                if (!multiSelectObj || !multiSelectObj.liCollections) return;

                multiSelectObj.listData.forEach((dataItem, index) => {
                    const sameProduct = dataItem.productId === productId;
                    const sameArea = pricingAreaId == null
                        ? dataItem.pricingAreaId == null
                        : dataItem.pricingAreaId === pricingAreaId;

                    if (sameProduct && sameArea) {
                        const li = multiSelectObj.liCollections[index];
                        if (!li) return;

                        li.classList.remove('e-disabled');
                        li.style.pointerEvents = 'auto';
                        li.style.opacity = '1';
                        li.setAttribute('aria-disabled', 'false');
                    }
                });

                multiSelectObj.dataBind();
            },
            onPopupOpen: function () {
                const multiSelectObj = this.$refs.mlsIdentifiers.ej2Instances;
                if (!multiSelectObj || !multiSelectObj.liCollections) return;

                // 1?? Reset all items first
                multiSelectObj.liCollections.forEach(li => {
                    li.classList.remove('e-disabled');
                    li.style.pointerEvents = 'auto';
                    li.style.opacity = '1';
                    li.setAttribute('aria-disabled', 'false');
                });

                // 2?? Apply blocked combinations
                if (!this.blockedCombinations || this.blockedCombinations.length === 0) return;

                setTimeout(() => {
                    const popupElement = document.querySelector('.e-ddl.e-popup.e-multi-select-list-wrapper');
                    if (!popupElement) return;

                    const listItems = popupElement.querySelectorAll('li.e-list-item');

                    multiSelectObj.listData.forEach((dataItem, index) => {
                        const isBlocked = this.blockedCombinations.some(b =>
                            b.productId === dataItem.productId &&
                            (b.areaId == null
                                ? dataItem.pricingAreaId == null
                                : dataItem.pricingAreaId === b.areaId)
                        );

                        const isSelected =
                            multiSelectObj.value && multiSelectObj.value.includes(dataItem.id);

                        if (isBlocked && !isSelected && listItems[index]) {
                            const li = listItems[index];
                            li.classList.add('e-disabled');
                            li.style.pointerEvents = 'none';
                            li.style.opacity = '0.5';
                            li.setAttribute('aria-disabled', 'true');
                        }
                    });
                }, 50);
            },
            onIdentifierSelect: function (e) {
                if (!e || !e.itemData) return;

                const { productId, pricingAreaId } = e.itemData;
                // Initialize blockedCombinations if needed
                if (!this.blockedCombinations) this.blockedCombinations = [];

                const alreadyBlocked = this.blockedCombinations.some(
                    b => b.productId === productId && b.areaId === pricingAreaId
                );

                if (!alreadyBlocked) {
                    this.blockedCombinations.push({
                        productId,
                        areaId: pricingAreaId
                    });
                }
            },
            populateIdentifier: function (utilityId, stateId, productIds, pricingAreaIds, isChangeEvent, preloadedIdentifiers = []) {
                this.identifierEnabled = false;

                //// Reset only on initial load
                if (isChangeEvent) { //d
                    //console.log("Checkpoint isChangeEvent reached!");
                    // Remove identifiers from the selection if their ProductId is no longer in the productIds list
                    if (Array.isArray(this.preIdentifierIds) && this.preIdentifierIds.length > 0) {
                        this.preIdentifierIds = this.preIdentifierIds.filter(key => {
                            const parts = key.split('_');
                            const pId = parseInt(parts[3]);
                            const aId = parts[4] === 'null' ? null : parseInt(parts[4]);

                            // Keep only if the product is still selected
                            const productStillExists = productIds.includes(pId);

                            // If area is selected, also check if area still exists
                            const areaStillExists = aId === null || (pricingAreaIds && pricingAreaIds.includes(aId));

                            return productStillExists && areaStillExists;
                        });

                        // Sync blocked combinations too
                        if (Array.isArray(this.blockedCombinations)) {
                            this.blockedCombinations = this.blockedCombinations.filter(b =>
                                productIds && Array.isArray(productIds) && productIds.includes(b.productId)
                            );
                        }
               
                    }

                } else {
                    // Initial load logic
                    this.preIdentifierIds = [];
                    this.blockedCombinations = [];
                }

                if (!stateId || !utilityId || !productIds || !productIds.length) return;

                const productParam = Array.isArray(productIds) ? productIds.join(',') : productIds;
                const areaParam = Array.isArray(pricingAreaIds) ? pricingAreaIds.join(',') : pricingAreaIds;

                apis.protectedApi(`utils/getIdentifiers?utilityTypeId=${utilityId}&stateId=${stateId}&productIds=${productParam}&pricingAreaIds=${areaParam}`)
                    .then(response => {
                        const apiIdentifiers = (response.data || []).map(item => ({
                            ...item,
                            compositeKey: `${item.sourceTypeId}_${item.identifierSourceId}_${item.contractToIdentifierSourceId || 0}_${item.productId}_${item.pricingAreaId}`
                        }));

                        // Merge preloaded identifiers
                        preloadedIdentifiers.forEach(pre => {
                            const existsIndex = apiIdentifiers.findIndex(i =>
                                i.sourceTypeId === pre.sourceTypeId &&
                                i.identifierSourceId === pre.identifierSourceId
                            );

                            if (existsIndex >= 0) {
                                // Replace API version with preloaded version
                                apiIdentifiers[existsIndex] = {
                                    ...apiIdentifiers[existsIndex],
                                    ...pre,
                                    compositeKey: `${pre.sourceTypeId}_${pre.identifierSourceId}_${pre.contractToIdentifierSourceId || 0}_${pre.productId}_${pre.pricingAreaId}`
                                };
                            } else {
                                // Add missing preloaded identifier
                                apiIdentifiers.push({
                                    ...pre,
                                    compositeKey: `${pre.sourceTypeId}_${pre.identifierSourceId}_${pre.contractToIdentifierSourceId || 0}_${pre.productId}_${pre.pricingAreaId}`
                                });
                            }
                        });

                        this.identifiers = apiIdentifiers;

                        //// Populate preIdentifierIds for MultiSelect
                        this.preIdentifierIds = preloadedIdentifiers.map(s =>
                            `${s.sourceTypeId}_${s.identifierSourceId}_${s.contractToIdentifierSourceId || 0}_${s.productId}_${s.pricingAreaId}`
                        );

                        // Enable MultiSelect if identifiers exist
                        if (this.identifiers.length > 0) {
                            this.$refs.mlsIdentifiers.ej2Instances.enabled = true;
                        }


                        if (!isChangeEvent && preloadedIdentifiers.length > 0) {

                            preloadedIdentifiers.forEach(s => {
                                const exists = this.blockedCombinations.some(
                                    b => b.productId === s.productId && b.areaId === s.pricingAreaId
                                );

                                if (!exists) {
                                    this.blockedCombinations.push({
                                        productId: s.productId,
                                        areaId: s.pricingAreaId
                                    });
                                }
                            });
                        }


                    })
                    .catch(e => {
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            onPriceAreaChange: function (e) {
                // e.value is the selected price area IDs
                if (!e || !e.value || !e.value.length) {
                    return;
                }

                // required dependencies
                if (!this.preStateId || !this.preUtilityId || !this.preProductIds || !this.preProductIds.length) {
                    return;
                }

                this.populateIdentifier(
                    this.preUtilityId,
                    this.preStateId,
                    this.preProductIds,
                    e.value,
                    true
                );
            },
            populatePriceAreas: function (stateId, utilityTypeId, productIds, isChangeEvent, savedIdentifiers = []) {
                this.prePricingAreaIds = null;
                apis.protectedApi(`utils/priceAreasForState?stateId=${stateId}&utilityTypeId=${utilityTypeId}&productIds=${productIds}`)
                    .then(response => {
                        this.priceAreas = response.data;
                        if (this.priceAreas.length > 0) {
                            this.$refs.mlsPriceAreas.ej2Instances.enabled = true;
                            this.contractForms.rules.priceAreas.required = true;
                            const arrayFields = ["priceAreas"]
                            setTimeout(function () {
                                arrayFields.forEach(function (item) {
                                    let inputElement = document.getElementById(item);
                                    if (inputElement) {
                                        let parentDiv = inputElement.closest('.input-group');
                                        if (parentDiv) {
                                            parentDiv.classList.add('required-input');
                                        }
                                    }
                                });
                            }, 300);
                        }
                        else {
                            this.$refs.mlsPriceAreas.ej2Instances.enabled = false;
                            this.contractForms.rules.priceAreas.required = false;
                            this.populateIdentifier(
                                utilityTypeId,
                                stateId,
                                productIds,
                                isChangeEvent ? null : this.data.pricingAreaIds,
                                isChangeEvent,
                                savedIdentifiers 
                            );
                        }

                        setTimeout(() => {
                            this.prePricingAreaIds = isChangeEvent ? null : this.data.pricingAreaIds;
                        }, 1000)

                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.supplierEnabled = true;
                this.identifierEnabled = true;
            },
            onSuppliersChange: function (e) {
                this.populateUtilities(e.itemData.id, true);
            },
            onStrategyInPlace: function (e) {
                this.enableStrategySection(this.$refs.dplStrategyInPlace.ej2Instances.value);
            },
            onVolumeDataBound: function (e) {
                var volumeUnit = this.volumeUnits.filter(p => p.id == this.data.volumeUnitId)[0];
                store.commit('setContractVolumeUnit', volumeUnit ? volumeUnit.name : "");
                store.commit('setContractVolumeUnitName', volumeUnit ? volumeUnit.volumeName : "");

            },
            enableStrategySection: function (enabled) {
                if (enabled) {
                    this.$refs.dplStrategyType.ej2Instances.enabled = true;
                    //this.$refs.dplStrategyType.ej2Instances.placeholder = "Strategy Type *";
                    this.$refs.dplStrategySignedDate.ej2Instances.enabled = true;
                    //this.$refs.dplStrategySignedDate.ej2Instances.placeholder = "Strategy Signed Date *";
                    this.$refs.uploadStrategy.ej2Instances.enabled = true;
                    this.contractForms.addRules('strategyType', { required: true });
                    this.contractForms.addRules('strategySignedDate', { required: true });

                    const arrayFields = ["strategyType", "strategySignedDate"]
                    arrayFields.forEach(function (item) {
                        let inputElement = document.getElementById(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                } else {

                    this.contractForms.addRules('strategyType', { required: false });
                    this.contractForms.addRules('strategySignedDate', { required: false });

                    if (document.getElementById('strategyType-info') != null) {
                        document.getElementById('strategyType-info').style.display = "none";
                    }
                    if (document.getElementById('strategySignedDate-info') != null) {
                        document.getElementById('strategySignedDate-info').style.display = "none";
                    }
                    const arrayFields = ["strategyType", "strategySignedDate"]
                    arrayFields.forEach(function (item) {
                        let inputElement = document.getElementById(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.input-group');
                            if (parentDiv) {
                                parentDiv.classList.remove('required-input');
                            }
                        }
                    });

                    this.$refs.dplStrategyType.ej2Instances.enabled = false;
                    this.$refs.dplStrategyType.ej2Instances.value = null
                    this.$refs.dplStrategyType.ej2Instances.placeholder = "Strategy Type";
                    this.$refs.dplStrategySignedDate.ej2Instances.enabled = false;
                    this.$refs.dplStrategySignedDate.ej2Instances.value = null;
                    this.$refs.dplStrategySignedDate.ej2Instances.placeholder = "Strategy Signed Date";
                    this.$refs.uploadStrategy.ej2Instances.enabled = false;
                    this.$refs.uploadStrategy.ej2Instances.value = null;
                }
            },
            onTradablePeriodChange: function (e) {
                if (e != undefined) {
                    if (e.isInteracted == true) {
                        this.$refs.dplDefaultMechanism.ej2Instances.enabled = true;
                        this.defaultMechanismId = null;
                        this.displayAutoFixType = false;
                        this.autoFixTypeName = null;
                        this.autoFixTypePeriodId = null;
                    }
                }
            },
            populateFutureExchange: function (stateId, isChangeEvent) {
                apis.protectedApi(`utils/futureexchange?stateId=${stateId}`)
                    .then(response => {
                        this.futureExchange = response.data;
                        setTimeout(() => {
                            this.preFutureExchangeId = isChangeEvent ? null : this.data.futureExchangeId;
                        }, 1000)
                        this.$refs.dplFutureExchange.ej2Instances.enabled = true;
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            populateSpotExchanges: function (stateId, isChangeEvent) {
                apis.protectedApi(`utils/spotexchanges?stateId=${stateId}`)
                    .then(response => {
                        this.spotExchanges = response.data;
                        setTimeout(() => {
                            this.preSpotExchangesId = isChangeEvent ? null : this.data.spotExchangeId;
                        }, 1000)
                        this.$refs.dplSpotExchange.ej2Instances.enabled = true;
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            syncData: function () {
                apis.protectedApi.put(`defaultDeadlineMechanism/historicalMechanismTrigger?contractId=${store.state.selectedContractId}`, { contractid: store.state.selectedContractId }).then(response => {
                    gridOptions.infoAlert("Data sent to processing");
                }).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
        },
        updated() {
            this.$nextTick(function () {
                if (this.isInATG || this.contractHasActiveTrades) {
                    this.isContractInATG();
                }
                hideSpinner(document.getElementById('mainSpinner'));
            })
        },
        computed: {
            clients() {

                return SyncHelper.getDataManager("utils/parentclients?userId=" + this.$store.state.loggedInUserId);

            },
            riskManagers() {
                return SyncHelper.getDataManager("utils/riskmanagers");
            },
            //futureExchange() {
            //    return SyncHelper.getDataManager("utils/futureexchange");
            //},
            //spotExchanges() {
            //    return SyncHelper.getDataManager("utils/spotexchanges");
            //},

            referenceTypes() {
                return SyncHelper.getDataManager("utils/referencetypes");
            },
            TradablePeriods() {
                return SyncHelper.getDataManager("utils/Tradableperiods");
            },
            strategyTypes() {
                return SyncHelper.getDataManager("utils/strategytypes");
            },
            defaultMechanism() {
                return SyncHelper.getDataManager("utils/getDefaultMechanismAll");
            },
            contractTypes() {
                return SyncHelper.getDataManager("utils/getContractType");
            }
        }
    }

</script>

<style>

    #contactsMain .e-control-wrapper .e-file-select,
    .e-control-wrapper .e-file-drop {
        display: none;
    }

    #contactsMain .e-upload-success {
        display: none;
    }

    #contactsMain .e-upload-files {
        display: none;
    }

    .loading {
        position: fixed;
        z-index: 1;
        /*height: 100%;
        width: 100%;*/
        background-color: lightgray;
        opacity: 0.6;
        overflow: hidden;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .uploader-noWidth {
        max-height: 60px;
        border: none !important;
        text-align: center;
    }

    .hideEl {
        display: none !important;
    }

    .contract-name-check .e-label {
        color: #8a93a2;
    }

    .box-auto {
        padding-right: 3.5rem !important;
    }

    .e-input-group {
        height: 30px;
    }

    .e-multiselect.e-input-group, .e-multiselect.e-float-input {
        word-wrap: initial;
        height: auto;
    }

    .e-multi-line-input {
        min-height: 50px;
        height: auto;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }

    .custom-white-chips.e-multiselect.e-input-group {
        background-color: white !important; 
    }

    /* One identifier per line */
    .custom-white-chips .e-chips {
        display: flex !important;
        background-color: white !important;
    }

        .custom-white-chips .e-chips .e-chipcontent {
            color: rgb(25,25,25) !important;
            -webkit-text-fill-color: rgb(25,25,25) !important;
        }
   /* 1. REVERSE THE BOX: Turn the whole container black when clicked/focused */
    .custom-white-chips.e-input-group.e-input-focus {
        background-color: white !important;
    }

    /* 2. REVERSE THE CHIPS: When the box is focused, turn the chips dark gray/black */
    .custom-white-chips.e-input-focus .e-chips {
        /*background-color: rgb(64,64,64) !important;*/
        background-color: #404040 !important;
        border: 1px solid #444 !important;
    }

        /* 3. REVERSE THE TEXT: Turn text white inside the focused box */
        .custom-white-chips.e-input-focus .e-chips .e-chipcontent {
            color: white !important;
            -webkit-text-fill-color: white !important;
        }

        /* 4. REVERSE THE ICON: Don't forget the 'X' button */
        .custom-white-chips.e-input-focus .e-chips .e-chips-close {
            color: white !important;
        }

    /* 1. Make the main container gray when disabled/readonly */
    .custom-white-chips.e-input-group.e-disabled,
    .custom-white-chips.e-input-group.e-readonly {
        background-color: #e9ecef !important; /* Standard Bootstrap gray */
        border-color: #ced4da !important;
    }

    /* 2. Remove the 'Chip' look so it looks like plain text */
    .custom-white-chips.e-disabled .e-chips,
    .custom-white-chips.e-readonly .e-chips {
        background-color: transparent !important; /* Removes the inner chip box */
        border: none !important; /* Removes the inner chip border */
        box-shadow: none !important;
        padding: 0 !important;
        margin-right: 5px !important;
    }

        /* 3. Style the text to be dark and clean */
        .custom-white-chips.e-disabled .e-chips .e-chipcontent,
        .custom-white-chips.e-readonly .e-chips .e-chipcontent {
            color: #495057 !important; /* Darker gray/black font */
            -webkit-text-fill-color: #495057 !important;
        }

        /* 4. Hide the 'X' icon (close button) entirely to match the top image */
        .custom-white-chips.e-disabled .e-chips .e-chips-close,
        .custom-white-chips.e-readonly .e-chips .e-chips-close {
            display: none !important;
        }
   
</style>